import script from "./GameCard.vue?vue&type=script&setup=true&lang=js"
export * from "./GameCard.vue?vue&type=script&setup=true&lang=js"

import "./GameCard.vue?vue&type=style&index=0&id=746f5a12&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-746f5a12"]])

export default __exports__